import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

// import * as actions from './actions'
import * as getters from './getters'
import modules from './modules'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    rootPath: process.env.VUE_APP_ROOT_PATH
  },
  modules,
  // actions,
  getters,
  strict: false // process.env.VUE_APP_NODE_ENV !== 'production'
})
